import { StatusIcon } from "@/molecules/StatusIcon"

import type { getReportJob } from "@/pages/ReportsPage/applications/useReports.selector"

export const ReportIdCell = (
  value: string,
  record: ReturnType<typeof getReportJob>["data"][number]
) => <StatusIcon status={record.statusValue.status}>{value}</StatusIcon>
